import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${(props) => props.theme.modalOverlay};
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 999;
  overflow-y: auto;
`;

const ModalContent = styled.div`
  background: ${(props) => props.theme.sidebarBackground};
  width: ${({ width }) => width || "600px"};
  height: ${({ height }) => height || "auto"};
  max-height: ${({ maxH }) => maxH || "85vh"};        
  min-height: ${({ minH }) => minH || "300px"}; 
  border-radius: 10px;
  overflow-y: auto;
  position: relative;
  margin-top: 60px; 
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  background-color: ${(props) => props.theme.modalHeader};
  color: white;
  padding: 16px;
  font-size: var(--app-font-size);
  font-weight: bold;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalChildren = styled.div`
  align-items: center;
  padding: ${({ padding }) => padding ?? "25px"};
  flex: 1;
  overflow: ${({ overflow }) => overflow ?? "hidden"};
`;

const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: white;
`;

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  width,
  minH,
  maxH,
  height,
  closeOnOverlay = false,
  closeOnEsc = true,
  padding,
  bodyOverflow,
}) => {
  React.useEffect(() => {
    if (!isOpen || !closeOnEsc || typeof onClose !== "function") return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, closeOnEsc, onClose]);

  if (!isOpen) return null;

  return (
    <Overlay onClick={closeOnOverlay ? onClose : undefined}>
      <ModalContent onClick={(e) => e.stopPropagation()} width={width} minH={minH} maxH={maxH} height={height}>
        <ModalHeader>
          {title}
          <CloseButton onClick={onClose} className="hover" aria-label="Cerrar">&times;</CloseButton>
        </ModalHeader>
        <ModalChildren padding={padding} overflow={bodyOverflow}>
          {children}
        </ModalChildren>
      </ModalContent>
    </Overlay>
  );
};

export default Modal;
